import React from "react";

import BackDrop from "../../../components/ui/BackDrop";
import { cn } from "../../../utils/twMerge";

import { datePickerIcon, closeIcon } from "../../../assetData/icons";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";

const MasterIndustryAddForm = ({
  form,
  segmentName,
  addHandler,
  closeHandler,
  isButtonClicked,
}) => {
  const errors = form.formState.errors;

  form.watch();
  const onSubmit = async (data) => {
    const statusValue = form.getValues("status") === "true";
    const updatedData = { ...data, status: statusValue };
    const res = await addHandler(updatedData);
    if (res) closeHandler();
  };

  const onClose = () => {
    closeHandler();
  };

  return (
    <>
      <div className="fixed left-1/2 z-50 mx-auto min-h-[300px] w-[98%] max-w-[1000px] -translate-x-1/2 rounded bg-white p-8 max-lg:top-[10%] lg:top-1/2 lg:-translate-y-1/2">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">{`Add ${segmentName}`}</h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="max-md:scrollbar-custom w-full overflow-x-hidden pr-2 max-lg:max-h-[550px] max-md:overflow-y-scroll md:overflow-y-hidden lg:max-h-[400px] ">
            {/* row 1 */}

            <div className="w-full items-baseline gap-2 lg:flex ">
              <div className="w-full items-baseline gap-2 sm:flex max-sm:[&>div]:mt-4 ">
                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">Industry *</label>
                  <input
                    placeholder="Type here"
                    {...form.register("industry")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.industry && "border-[1px] border-red-300",
                    )}
                  />
                </div>

                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">
                    Industry Code *
                  </label>
                  <input
                    placeholder="Type here"
                    {...form.register("industry_code")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.industry_code && "border-[1px] border-red-300",
                    )}
                  />
                </div>
              </div>
              <div className=" w-full items-stretch gap-4 text-neutral-600 max-lg:mt-4 sm:flex">
                <div className={cn("flex w-full flex-col gap-2")}>
                  <label className="text-base text-[#636363]">
                    Basic Industry *
                  </label>
                  <input
                    placeholder="Type here"
                    {...form.register("basic_industry")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.basic_industry && "border-[1px] border-red-300",
                    )}
                  />
                </div>

                <div className={cn("flex w-full flex-col gap-2 max-sm:mt-4")}>
                  <label className="text-base text-[#636363]">Sector *</label>
                  <input
                    placeholder="Type here"
                    {...form.register("sector")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.sector && "border-[1px] border-red-300",
                    )}
                  />
                </div>
              </div>
            </div>

            {/* row 3 */}
            <div className="mt-8 w-full items-end gap-2 max-lg:mt-4 lg:flex ">
              <div className="w-full items-end gap-2 max-lg:mt-4 sm:flex ">
                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">
                    Sector Code *
                  </label>
                  <input
                    placeholder="Type here"
                    {...form.register("sector_code")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.sector_code && "border-[1px] border-red-300",
                    )}
                  />
                </div>

                <div className={cn("flex w-full flex-col gap-2 max-sm:mt-4")}>
                  <label className="text-base text-[#636363]">MES *</label>
                  <input
                    placeholder="Type here"
                    {...form.register("macro_economic_sector")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.macro_economic_sector &&
                        "border-[1px] border-red-300",
                    )}
                  />
                </div>
              </div>
              <div className="w-full items-end gap-2 max-lg:mt-4 sm:flex ">
                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">MES code *</label>
                  <input
                    placeholder="Type here"
                    {...form.register("mes_code")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.mes_code && "border-[1px] border-red-300",
                    )}
                  />
                </div>

                <div className={cn("flex w-full flex-col gap-2 max-sm:mt-4")}>
                  <label className="text-base text-[#636363]">BI code *</label>
                  <input
                    placeholder="Type here"
                    {...form.register("bi_code")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.bi_code && "border-[1px] border-red-300",
                    )}
                  />
                </div>
              </div>
            </div>

            {/* row 2 */}
            <div className="mt-8 w-full items-end gap-2 max-lg:mt-4 lg:flex ">
              <div className="w-full items-end gap-2 sm:flex ">
                <div className={cn("flex w-full flex-col  gap-2")}>
                  <label className="text-base text-[#636363]">
                    Vidal Code *
                  </label>
                  <input
                    placeholder="Type here"
                    {...form.register("vidal_code")}
                    className={cn(
                      "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                      errors.vidal_code && "border-[1px] border-red-300",
                    )}
                  />
                </div>

                <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>Start date *</label>

                    <div className="relative flex w-full">
                      <input
                        type="date"
                        {...form.register("eff_start_date")}
                        className={cn(
                          "hide-calendar-picker h-full w-full rounded bg-neutral-100 p-2 px-2 text-[#636363] focus:outline-none",
                          errors.eff_start_date &&
                            "border-[1px] border-red-300",
                        )}
                      />
                      <img
                        src={datePickerIcon}
                        className="absolute right-1 top-1/2 w-[20px] -translate-y-1/2"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full items-end gap-2 max-lg:mt-4 sm:flex ">
                <div className=" flex w-full items-stretch gap-4 text-neutral-600">
                  <div className="flex w-full  flex-col gap-2 ">
                    <label>End date</label>

                    <div className="relative flex w-full">
                      <input
                        type="date"
                        {...form.register("eff_end_date")}
                        min={form.getValues("eff_start_date")}
                        className={cn(
                          "hide-calendar-picker h-full w-full rounded bg-neutral-100 p-2 px-2 text-[#636363] focus:outline-none",
                          errors.eff_end_date && "border-[1px] border-red-300",
                        )}
                      />
                      <img
                        src={datePickerIcon}
                        className="absolute right-1 top-1/2 w-[20px] -translate-y-1/2"
                      />
                    </div>
                  </div>
                </div>
                <div className={cn("flex w-full flex-col  gap-2")}></div>
              </div>
            </div>
          </div>

          {/* actions */}
          <div className="flex items-end max-sm:justify-center md:justify-between max-lg:[&>button]:w-[50%] max-sm:[&>button]:w-full lg:[&>button]:w-1/4">
            <button
              type="submit"
              disabled={isButtonClicked}
              className={` ${
                isButtonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-16 py-2 font-semibold text-white `}
            >
              {isButtonClicked ? <MirageLoader /> : "ADD"}
            </button>
            <button className="max-lg:hidden"></button>
            <button className="max-lg:hidden"></button>
          </div>
        </form>
      </div>
      <BackDrop
      //  closeHandler={closeHandler}
      />
    </>
  );
};

export default MasterIndustryAddForm;
